<template>
    <div class="r-auth-register-company container">
        <h2>Create account</h2>
        <div class="row justify-content-center">
            <form
                class="col-lg-7"
                @submit.prevent="handleSubmit"
            >
                <h4 class="mt-4 mb-4">Company data</h4>

                <!-- <base-select
                    name="country_code"
                    label="Country"
                    v-validate="'required'"
                    v-model="company.country_code"
                    :options="countriesOptions"
                    :err="errors.collect('country_code')"
                    valueBy="value"
                    @input="handleCheckVat"
                /> -->
                <base-select
                    name="country_code"
                    label="Country"
                    v-validate="'required'"
                    v-model="company.country_code"
                    :options="countriesOptions"
                    :err="errors.collect('country_code')"
                    valueBy="value"
                />

                <base-text
                    name="vat_number"
                    label="VAT without country code and without dots"
                    v-validate="'required|min:7|vat'"
                    v-model="company.vat_number"
                    :err="errors.collect('vat_number')"
                    :disabled="!company.country_code"
                />

                <base-text
                    name="name"
                    label="Name"
                    v-validate="'required'"
                    v-model="company.name"
                    :err="errors.collect('name')"
                />

                <base-text
                    name="address"
                    label="Address"
                    v-validate="'required'"
                    v-model="company.address"
                    :err="errors.collect('address')"
                />

                <base-text
                    label="Holding / group name"
                    v-model="company.holding"
                />

                <base-text
                    name="ceo_name"
                    label="Name of CEO"
                    v-validate="'required'"
                    v-model="company.ceo_name"
                    :err="errors.collect('ceo_name')"
                />

                <base-text
                    name="ceo_email"
                    label="Email of CEO"
                    v-validate="'required|email'"
                    v-model="company.ceo_email"
                    :err="errors.collect('ceo_email')"
                />

                <!-- <base-text
                    name="target"
                    type="number"
                    label="Target"
                    v-model="company.target"
                /> -->


                <div class="row mt-4">
                    <div class="col-6 text-left">
                        <base-button
                            radius="bl"
                            component-class="blue"
                            @click.native="$router.push({ name: 'auth-register' })"
                        ><i class="fas fa-arrow-left mr-3"></i> Previous
                        </base-button>
                    </div>
                    <div class="col-6 text-right">
                        <base-button
                            radius="br"
                            component-class="green filled"
                            type="submit"
                        > Register <i class="fas fa-arrow-right ml-3"></i>
                        </base-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import BaseButton from '@/components/inputs/button/BaseButton';
    import BaseText from '@/components/inputs/text/BaseText';
    import BaseSelect from '@/components/inputs/select/BaseSelect';

    export default {
        data() {
            return {
                company: {
                    vat_number: '',
                    name: '',
                    address: '',
                    country_code: '',
                    holding: '',
                    ceo_name: '',
                    ceo_email: '',
                    // target: '',
                }
            };
        },

        computed: {
            ...mapState({
                countries: state => state.countries.countries,
                authData: state => state.auth ? state.auth.data : {},
            }),
            countriesOptions() {
                return this.countries
                    .map((county) => {
                        return {
                            label: county.name,
                            value: county.code,
                        };
                    });
            },
        },

        methods: {
            async handleSubmit() {
                try {
                    const isValidForm = await this.$validator.validateAll();
                    if (isValidForm) {
                        const { role, name, email, password, is_input } = this.authData;
                        const company = {
                            name: this.company.name,
                            address: this.company.address,
                            country_code: this.company.country_code,
                            vat_number: this.company.vat_number,
                            holding: this.company.holding,
                            ceo_name: this.company.ceo_name,
                            ceo_email: this.company.ceo_email,
                            // target: this.company.target,
                        };

                        const credentials = {
                            role_id: role.value,
                            name,
                            email,
                            password,
                            comment: '',
                            company,
                            is_input,
                        };

                        this.$store.dispatch('auth/register', credentials);
                        this.$router.push({ name: 'auth-login'});
                    }
                } catch (error) {
                    console.error(error);
                }
            },

            async handleCheckVat() {
                const { country_code, vat_number } = this.company;
                if (country_code && vat_number.length > 5) {
                    try {
                        const { data } = await this.$store.dispatch('app/checkVat', { country_code, vat_number });
                        const { name, address } = data;
                        this.company.name = name;
                        this.company.address = address;
                        return data;
                    } catch (error) {
                        console.error(error);
                    }
                }
            },
        },

        created() {
            this.$validator.extend('vat', {
                getMessage: () => 'Vat number needs to be valid',
                validate: async (value, [testProp]) => {
                    console.log(value, testProp);
                    try {
                        const data = await this.handleCheckVat();
                        if (data.valid) {
                            return true;
                        }
                    } catch (error) {
                         console.log('error', error);
                    }

                    return false;
                }
            });
        },

        mounted() {
            this.$store.dispatch('countries/getCountries');
            if (Object.keys(this.authData).length === 0) {
                this.$router.push({ name: 'auth-register'});
            }
        },

        components: {
            'base-button': BaseButton,
            'base-text': BaseText,
            'base-select': BaseSelect
        }
    };
</script>
